define([
    "./nlgPasswordModule",
    "./nlgPasswordDirective",
    "./nlgPassword.less",
    "./nlgPasswordConfirmation/nlgPasswordConfirmationDirective",
    "./nlgPasswordService",
    "./passwordConfigProvider"
], function(){

});